// Guard
import { privateGuard } from "@/middlewares/guards";

// Layouts
import NavLayout from "../layouts/NavLayout.vue";

// Views
import Logistic from "../views/Logistic.vue";

export default [
  {
    path: "/logistic",
    beforeEnter: privateGuard,
    component: NavLayout,
    children: [
      {
        path: "",
        name: "Logistica",
        component: Logistic,
        meta: {
          title: "Logistic",
        },
      },
    ],
  },

];
